<template>
  <section class="document-attachments">
    <loader-dots v-if="loadStatus" />
    
    <list-items-loadable
      v-else
      v-slot="{ item }"
      :items="attachmentsItems"
      class="document-attachments__text"
      empty-text="Идёт загрузка приложений документа."
    >
      <div 
        class="document-attachments__item"
      > 
        <router-link :to="makeDocumentRoute(item.id)"> {{"Приложение " + item.name}} </router-link> 
      </div>
    </list-items-loadable>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';
import LoaderDots from '@@/shared/loaders/LoaderDots';

import DocumentRoute from '@@/document/mixins/DocumentRoute';
import NormaCsLinkHandler from '@@/document/mixins/NormaCsLinkHandler';


export default {
  components: {
    ListItemsLoadable,
    LoaderDots
  },

  mixins: [NormaCsLinkHandler, DocumentRoute],

  props: {
    documentId: {
      type: String,
      required: true
    },
    loadStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      attachmentsItems: 'currentDocumentAttachments'
    })
  },

  mounted() {
    this.initNormaCsLinkHandler(this.$el);
  }

};
</script>
